import { ThemeOptions } from '@mui/material';
import type {} from '@mui/x-charts/themeAugmentation';

import * as MuiBarChartConfig from './MuiBarChart';
import * as MuiChartsDataProviderConfig from './MuiChartsDataProvider';
import * as MuiGaugeConfig from './MuiGauge';
import * as MuiLineChartConfig from './MuiLineChart';
import * as MuiPieChartConfig from './MuiPieChart';
import * as MuiRadarChartConfig from './MuiRadarChart';
import * as MuiScatterChartConfig from './MuiScatterChart';

export type {} from './MuiBarChart';
export type {} from './MuiChartsDataProvider';
export type {} from './MuiGauge';
export type {} from './MuiLineChart';
export type {} from './MuiPieChart';
export type {} from './MuiRadarChart';
export type {} from './MuiScatterChart';

export const charts: ThemeOptions['components'] = {
  ...MuiBarChartConfig,
  ...MuiChartsDataProviderConfig,
  ...MuiGaugeConfig,
  ...MuiLineChartConfig,
  ...MuiPieChartConfig,
  ...MuiRadarChartConfig,
  ...MuiScatterChartConfig
};
